import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['source', 'button', 'originalText', 'copyIcon', 'checkIcon', 'buttonText'];
  static values = {
    originalText: String
  };

  copy() {
    const sourceText = 'value' in this.sourceTarget ? this.sourceTarget.value : this.sourceTarget.textContent;
    const text = sourceText.trim();

    if (!text) {
      this.showError();
      return;
    }

    // Run the fallback while the click still has user activation. Some mobile
    // privacy browsers reject Clipboard API calls, then block a delayed fallback.
    if (this.copyWithExecCommand(text)) {
      this.showSuccess();
      return;
    }

    this.copyWithClipboard(text);
  }

  async copyWithClipboard(text) {
    if (!navigator.clipboard || !window.isSecureContext) {
      this.showError();
      return;
    }

    try {
      await navigator.clipboard.writeText(text);
      this.showSuccess();
    } catch (error) {
      console.error('Clipboard copy failed:', error);
      this.showError();
    }
  }

  copyWithExecCommand(text) {
    const activeElement = document.activeElement;
    const textArea = document.createElement('textarea');

    textArea.value = text;
    textArea.readOnly = true;
    textArea.setAttribute('aria-hidden', 'true');
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.width = '1px';
    textArea.style.height = '1px';
    textArea.style.padding = '0';
    textArea.style.border = '0';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);

    try {
      textArea.focus({ preventScroll: true });
      textArea.select();
      textArea.setSelectionRange(0, text.length);
      return document.execCommand('copy');
    } catch (error) {
      console.warn('Fallback copy failed:', error);
      return false;
    } finally {
      textArea.remove();
      if (typeof activeElement?.focus === 'function') {
        activeElement.focus({ preventScroll: true });
      }
    }
  }

  showSuccess() {
    this.buttonTextTarget.textContent = 'Copiado!';
    this.buttonTarget.classList.remove('bg-blue-600', 'hover:bg-blue-700');
    this.buttonTarget.classList.add('bg-green-600', 'hover:bg-green-700');

    if (this.hasCopyIconTarget) {
      this.copyIconTarget.classList.add('hidden');
    }
    if (this.hasCheckIconTarget) {
      this.checkIconTarget.classList.remove('hidden');
    }

    setTimeout(() => {
      this.resetButton();
    }, 2000);
  }

  showError() {
    this.buttonTextTarget.textContent = 'Copie manualmente';

    setTimeout(() => {
      this.resetButton();
    }, 3000);
  }

  resetButton() {
    this.buttonTextTarget.textContent = this.originalTextValue;
    this.buttonTarget.classList.remove('bg-green-600', 'hover:bg-green-700', 'bg-red-600', 'hover:bg-red-700');
    this.buttonTarget.classList.add('bg-blue-600', 'hover:bg-blue-700');

    if (this.hasCopyIconTarget) {
      this.copyIconTarget.classList.remove('hidden');
    }
    if (this.hasCheckIconTarget) {
      this.checkIconTarget.classList.add('hidden');
    }
  }
}
